import { createFileRoute } from '@tanstack/react-router';
import { Header, Footer } from '@/components/marketing';
import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

export const Route = createFileRoute('/changelog')({
  component: ChangelogPage,
});

const changelogEntries = [
  {
    version: '2.0.0',
    date: 'December 2024',
    badge: 'Latest',
    title: 'Core-Forge Platform Launch',
    changes: [
      'New multi-product architecture with CodeSpringForge as first module',
      'Enhanced entitlement system with tier-based access control',
      'Full Prometheus metrics and tracing instrumentation',
      'Health check endpoints for improved reliability',
    ],
  },
  {
    version: '1.5.0',
    date: 'November 2024',
    badge: null,
    title: 'Security Scanning Enhancement',
    changes: [
      'Added comprehensive vulnerability detection',
      'SBOM generation for dependency tracking',
      'Threat modeling capabilities for architecture analysis',
    ],
  },
  {
    version: '1.0.0',
    date: 'June 2024',
    badge: null,
    title: 'Initial Release',
    changes: [
      'Repository upload and analysis',
      'Feature extraction from code',
      'PRD generation',
      'Basic export capabilities',
    ],
  },
];

function ChangelogPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1 pt-24 pb-16">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <Badge variant="secondary" className="mb-4">Changelog</Badge>
            <h1 className="text-4xl font-bold tracking-tight sm:text-5xl mb-4">What's New</h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Stay up to date with the latest features and improvements.
            </p>
          </div>
          <div className="max-w-3xl mx-auto space-y-8">
            {changelogEntries.map((entry, index) => (
              <Card key={entry.version} className={index === 0 ? 'border-primary' : ''}>
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <span className="text-2xl font-bold">v{entry.version}</span>
                      {entry.badge && <Badge className="bg-primary text-primary-foreground">{entry.badge}</Badge>}
                    </div>
                    <span className="text-sm text-muted-foreground">{entry.date}</span>
                  </div>
                  <CardTitle className="text-lg mt-2">{entry.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <ul className="space-y-2">
                    {entry.changes.map((change, i) => (
                      <li key={i} className="flex items-start gap-2 text-muted-foreground">
                        <span className="text-primary mt-1.5">•</span>
                        <span>{change}</span>
                      </li>
                    ))}
                  </ul>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
